export default __webpack_public_path__ + "static/media/Bifana-3.e74c1f5d.jpg";